import React from 'react';

// Routes
import Routes from './dash-calculators-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
